import { openverseFullIcon } from '../utils/icons';

const OpenverseFullIcon = () => {
    return <div className="openverseIcon">
        {openverseFullIcon}
    </div>
}
export default OpenverseFullIcon;